<div class="ab-lab-req">
    <form *ngIf="form" [formGroup]="form">
        <div style="display: flex; flex-direction: column">
            <div class="grid1" style="border-right: 1px solid black">
                <div class="div1">
                    <div style="display: flex; justify-content: space-between">
                        <div>
                            <div class="logo"></div>
                        </div>
                        <div
                            style="
                                display: flex;
                                flex-direction: column;
                                align-items: center;
                            "
                        >
                            <div class="heading">
                                General Laboratory Requisition
                            </div>
                            <div>
                                Alberta Precision Laboratories 1-877-868-6848
                            </div>
                            <div>
                                DynaLIFE Medical Labs 1-800-661-9876 or
                                780-451-3702
                            </div>
                            <div>
                                <b
                                    >Appointment Booking & Locations:
                                    www.albertaprecisionlabs.ca or
                                    www.dynalife.ca</b
                                >
                            </div>
                            <div>
                                For quicker access to key test results, visit:
                                alberta.ca/MHR
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    class="div2"
                    style="
                        border: 1px solid black;
                        border-right: none;
                        padding: 4px;
                    "
                >
                    <div>Scanning Label or Accession # (lab only)</div>
                    <div>
                        <textarea
                            formControlName="accession"
                            rows="7"
                        ></textarea>
                    </div>
                </div>
                <ng-container formGroupName="patient">
                    <div
                        class="div3"
                        style="
                            border: 1px solid black;
                            border-bottom-left-radius: 20px;
                            border-top-left-radius: 20px;
                            background-color: rgb(204, 255, 238);
                            display: flex;
                            align-items: center;
                            justify-content: center;
                        "
                    >
                        <div
                            class="heading"
                            style="
                                transform: rotate(180deg);
                                writing-mode: vertical-lr;
                            "
                        >
                            Patient
                        </div>
                    </div>
                    <div
                        class="div4"
                        style="padding: 4px; border-top: 1px solid black"
                    >
                        <div>PHN</div>
                        <div style="display: flex; align-items: center">
                            <input formControlName="PHN" type="text" />
                            <div>Expiry:</div>
                            <input
                                formControlName="exp"
                                type="text"
                                style="
                                    border-bottom: 1px solid black;
                                    width: 70px;
                                "
                            />
                        </div>
                    </div>
                    <div
                        class="div5"
                        style="
                            padding: 4px;
                            border-top: 1px solid black;
                            border-left: 1px solid black;
                        "
                    >
                        <div>Date of Birth <small>(dd-Mon-yyyy)</small></div>
                        <div>
                            <input formControlName="dob" type="text" />
                        </div>
                    </div>
                    <div
                        class="div6"
                        style="padding: 4px; border-top: 1px solid black"
                    >
                        <div>Legal Last Name</div>
                        <div>
                            <input formControlName="lastName" type="text" />
                        </div>
                    </div>
                    <div
                        class="div7"
                        style="
                            padding: 4px;
                            border-top: 1px solid black;
                            border-left: 1px solid black;
                        "
                    >
                        <div>Legal First Name</div>
                        <div>
                            <input formControlName="firstName" type="text" />
                        </div>
                    </div>
                    <div
                        class="div8"
                        style="padding: 4px; border-left: 1px solid black"
                    >
                        <div>Middle Name</div>
                        <div>
                            <input formControlName="middleName" type="text" />
                        </div>
                    </div>
                    <div class="div9" style="border-top: 1px solid black">
                        <div
                            style="
                                display: flex;
                                align-items: center;
                                justify-content: space-between;
                                height: 100%;
                                align-items: stretch;
                            "
                        >
                            <div style="padding: 4px">
                                <div>Alternate Identifier</div>
                                <div>
                                    <input
                                        formControlName="alternateIdentifier"
                                        type="text"
                                    />
                                </div>
                            </div>
                            <div
                                style="
                                    padding: 4px;
                                    border-left: 1px solid black;
                                "
                            >
                                <div>Preferred Name</div>
                                <div>
                                    <input
                                        formControlName="preferredName"
                                        type="text"
                                    />
                                </div>
                            </div>
                            <div
                                style="
                                    padding: 4px;
                                    border-left: 1px solid black;
                                "
                            >
                                <div
                                    style="
                                        display: grid;
                                        grid-template-columns: repeat(2, 1fr);
                                        grid-template-rows: repeat(2, 1fr);
                                        grid-column-gap: 0px;
                                        grid-row-gap: 0px;
                                    "
                                >
                                    <div style="grid-area: 1 / 1 / 2 / 2">
                                        <label>
                                            <input
                                                formControlName="male"
                                                type="checkbox"
                                            />
                                            Male
                                        </label>
                                    </div>
                                    <div style="grid-area: 1 / 2 / 2 / 3">
                                        <label>
                                            <input
                                                formControlName="female"
                                                type="checkbox"
                                            />
                                            Female
                                        </label>
                                    </div>
                                    <div style="grid-area: 2 / 1 / 3 / 2">
                                        <label>
                                            <input
                                                formControlName="nonBinary"
                                                type="checkbox"
                                            />
                                            Non-binary
                                        </label>
                                    </div>
                                    <div style="grid-area: 2 / 2 / 3 / 3">
                                        <label>
                                            <input
                                                formControlName="PreferNotToDisclose"
                                                type="checkbox"
                                            />
                                            Prefer not to disclose
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div
                                style="
                                    padding: 4px;
                                    border-left: 1px solid black;
                                "
                            >
                                <div>Phone</div>
                                <div>
                                    <input
                                        formControlName="phone"
                                        type="text"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        class="div10"
                        style="padding: 4px; border-top: 1px solid black"
                    >
                        <div>Address</div>
                        <div>
                            <input formControlName="address" type="text" />
                        </div>
                    </div>
                    <div
                        class="div11"
                        style="
                            padding: 4px;
                            border-top: 1px solid black;
                            border-left: 1px solid black;
                        "
                    >
                        <div>City/Town</div>
                        <div><input formControlName="city" type="text" /></div>
                    </div>
                    <div class="div12" style="border-top: 1px solid black">
                        <div
                            style="
                                display: flex;
                                align-items: stretch;
                                height: 100%;
                            "
                        >
                            <div
                                style="
                                    flex: 1;
                                    padding: 4px;
                                    border-left: 1px solid black;
                                "
                            >
                                <div>Prov</div>
                                <div>
                                    <input formControlName="prov" type="text" />
                                </div>
                            </div>
                            <div
                                style="
                                    flex: 1;
                                    padding: 4px;
                                    border-left: 1px solid black;
                                "
                            >
                                <div>Postal Code</div>
                                <div>
                                    <input
                                        formControlName="postal"
                                        type="text"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>
                <ng-container formGroupName="provider">
                    <div
                        class="div13"
                        style="
                            border: 1px solid black;
                            border-bottom-left-radius: 20px;
                            border-top-left-radius: 20px;
                            background-color: rgb(204, 255, 238);
                            display: flex;
                            align-items: center;
                            justify-content: center;
                        "
                    >
                        <div
                            class="heading"
                            style="
                                transform: rotate(180deg);
                                writing-mode: vertical-lr;
                            "
                        >
                            Provider(s)
                        </div>
                    </div>
                    <div
                        class="div14"
                        style="padding: 4px; border-top: 1px solid black"
                    >
                        <div>
                            Authorizing Provider Name
                            <small>(last, first, middle)</small>
                        </div>
                        <div><input formControlName="name" type="text" /></div>
                    </div>
                    <div
                        class="div15"
                        style="
                            padding: 4px;
                            border-top: 1px solid black;
                            border-left: 1px solid black;
                        "
                    >
                        <div>
                            Copy to Name <small>(last, first, middle)</small>
                        </div>
                        <div>
                            <input formControlName="copyName1" type="text" />
                        </div>
                    </div>
                    <div
                        class="div16"
                        style="
                            padding: 4px;
                            border-top: 1px solid black;
                            border-left: 1px solid black;
                        "
                    >
                        <div>
                            Copy to Name <small>(last, first, middle)</small>
                        </div>
                        <div>
                            <input formControlName="copyName2" type="text" />
                        </div>
                    </div>
                    <div
                        class="div17"
                        style="padding: 4px; border-top: 1px solid black"
                    >
                        <div>Address</div>
                        <div>
                            <input formControlName="address" type="text" />
                        </div>
                    </div>
                    <div
                        class="div18"
                        style="
                            padding: 4px;
                            border-top: 1px solid black;
                            border-left: 1px solid black;
                        "
                    >
                        <div>Phone</div>
                        <div><input formControlName="phone" type="text" /></div>
                    </div>
                    <div
                        class="div19"
                        style="
                            padding: 4px;
                            border-top: 1px solid black;
                            border-left: 1px solid black;
                        "
                    >
                        <div>Address</div>
                        <div>
                            <input formControlName="address1" type="text" />
                        </div>
                    </div>
                    <div
                        class="div20"
                        style="
                            padding: 4px;
                            border-top: 1px solid black;
                            border-left: 1px solid black;
                        "
                    >
                        <div>Address</div>
                        <div>
                            <input formControlName="address2" type="text" />
                        </div>
                    </div>
                    <div
                        class="div21"
                        style="padding: 4px; border-top: 1px solid black"
                    >
                        <div>CC Provider ID</div>
                        <div>
                            <input formControlName="ccProviderId" type="text" />
                        </div>
                    </div>
                    <div
                        class="div22"
                        style="
                            padding: 4px;
                            border-top: 1px solid black;
                            border-left: 1px solid black;
                        "
                    >
                        <div>CC Submitter ID</div>
                        <div>
                            <input
                                formControlName="ccSubmitterId"
                                type="text"
                            />
                        </div>
                    </div>
                    <div
                        class="div23"
                        style="
                            padding: 4px;
                            border-top: 1px solid black;
                            border-left: 1px solid black;
                        "
                    >
                        <div>Legacy ID</div>
                        <div>
                            <input formControlName="legacyId" type="text" />
                        </div>
                    </div>
                    <div
                        class="div24"
                        style="
                            padding: 4px;
                            border-top: 1px solid black;
                            border-left: 1px solid black;
                        "
                    >
                        <div>Phone</div>
                        <div>
                            <input formControlName="phone1" type="text" />
                        </div>
                    </div>
                    <div
                        class="div25"
                        style="
                            padding: 4px;
                            border-top: 1px solid black;
                            border-left: 1px solid black;
                        "
                    >
                        <div>Phone</div>
                        <div>
                            <input formControlName="phone2" type="text" />
                        </div>
                    </div>
                    <div
                        class="div26"
                        style="padding: 4px; border-top: 1px solid black"
                    >
                        <div>Clinic Name</div>
                        <div>
                            <input formControlName="clinicName" type="text" />
                        </div>
                    </div>
                    <div
                        class="div27"
                        style="
                            padding: 4px;
                            border-top: 1px solid black;
                            border-left: 1px solid black;
                        "
                    >
                        <div>Clinic Name</div>
                        <div>
                            <input formControlName="clinicName1" type="text" />
                        </div>
                    </div>
                    <div
                        class="div28"
                        style="
                            padding: 4px;
                            border-top: 1px solid black;
                            border-left: 1px solid black;
                        "
                    >
                        <div>Clinic Name</div>
                        <div>
                            <input formControlName="clinicName2" type="text" />
                        </div>
                    </div>
                </ng-container>
                <ng-container formGroupName="collection">
                    <div
                        class="div29"
                        style="display: flex; justify-content: space-between"
                    >
                        <div
                            style="
                                flex: 1;
                                border: 1px solid black;
                                border-bottom-left-radius: 20px;
                                border-top-left-radius: 20px;
                                background-color: rgb(204, 255, 238);
                                display: flex;
                                align-items: center;
                                justify-content: center;
                            "
                        >
                            <div class="heading">Collection</div>
                        </div>
                        <div
                            style="
                                padding: 4px;
                                border-top: 1px solid black;
                                border-bottom: 1px solid black;
                            "
                        >
                            <div>Date <small>(dd-Mon-yyyy)</small></div>
                            <div>
                                <input formControlName="date" type="text" />
                            </div>
                        </div>
                    </div>
                    <div
                        class="div30"
                        style="
                            padding: 4px;
                            border-top: 1px solid black;
                            border-left: 1px solid black;
                            border-bottom: 1px solid black;
                        "
                    >
                        <div>Time <small>(24 hr)</small></div>
                        <div><input formControlName="time" type="text" /></div>
                    </div>
                    <div
                        class="div31"
                        style="
                            padding: 4px;
                            border-top: 1px solid black;
                            border-left: 1px solid black;
                            border-bottom: 1px solid black;
                        "
                    >
                        <div>Location</div>
                        <div>
                            <input formControlName="location" type="text" />
                        </div>
                    </div>
                    <div
                        class="div32"
                        style="
                            padding: 4px;
                            border-top: 1px solid black;
                            border-left: 1px solid black;
                            border-bottom: 1px solid black;
                        "
                    >
                        <div>Collector ID</div>
                        <div>
                            <input formControlName="collectorId" type="text" />
                        </div>
                    </div>
                </ng-container>
            </div>

            <div class="grid2" style="border: 1px solid black">
                <ng-container formGroupName="fasting">
                    <div class="div1">
                        <div style="display: flex; height: 100%">
                            <div style="flex: 1; padding: 4px">
                                <div>
                                    <label>
                                        <input
                                            formControlName="routine"
                                            type="checkbox"
                                        />
                                        Routine
                                    </label>
                                </div>
                                <div>
                                    <label>
                                        <input
                                            formControlName="stat"
                                            type="checkbox"
                                        />
                                        Stat
                                    </label>
                                </div>
                            </div>
                            <div
                                style="
                                    padding: 4px;
                                    border-left: 1px solid black;
                                "
                            >
                                <div>Requisition Date</div>
                                <div>
                                    <input
                                        formControlName="requisitionDate"
                                        type="text"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        class="div2"
                        style="border-left: 1px solid black; padding: 4px"
                    >
                        <div>Ⓕ Denotes a <b>Fasting Test</b>.</div>
                        <div>Ⓘ Refer to Patient Instruction Sheet.</div>
                    </div>
                    <div class="div3">
                        <div style="display: flex; height: 100%">
                            <div
                                style="
                                    padding: 4px;
                                    border-left: 1px solid black;
                                "
                            >
                                <div>Hours Fasting</div>
                                <div>
                                    <input
                                        formControlName="hoursFasting"
                                        style="border-bottom: 1px solid black"
                                        type="text"
                                    />
                                </div>
                            </div>

                            <div
                                style="
                                    flex: 1;
                                    padding: 4px;
                                    border-left: 1px solid black;
                                "
                            >
                                <div>
                                    <label>
                                        <input
                                            formControlName="thirdPartyBill"
                                            type="checkbox"
                                        />
                                        Third Party Bill
                                    </label>
                                </div>
                                <div style="display: flex">
                                    <label> Client </label
                                    ><input
                                        formControlName="client"
                                        style="border-bottom: 1px solid black"
                                        type="text"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>
                <div
                    class="div4"
                    formGroupName="hematology"
                    style="border-top: 1px solid black"
                >
                    <div class="heading">Hematology/Coagulation</div>
                    <div style="padding: 4px">
                        <div
                            style="
                                display: grid;
                                grid-template-columns: repeat(2, 1fr);
                                grid-template-rows: repeat(4, 1fr);
                                grid-column-gap: 0px;
                                grid-row-gap: 0px;
                            "
                        >
                            <div style="grid-area: 1 / 1 / 2 / 2">
                                <label>
                                    <input
                                        formControlName="cbcAndDifferential"
                                        type="checkbox"
                                    />
                                    CBC and Differential
                                </label>
                            </div>
                            <div style="grid-area: 2 / 1 / 3 / 2">
                                <label>
                                    <input
                                        formControlName="dDimer"
                                        type="checkbox"
                                    />
                                    D-dimer
                                </label>
                            </div>
                            <div style="grid-area: 3 / 1 / 4 / 2">
                                <label>
                                    <input
                                        formControlName="INR"
                                        type="checkbox"
                                    />
                                    INR
                                </label>
                            </div>
                            <div style="grid-area: 4 / 1 / 5 / 2">
                                <label>
                                    <input
                                        formControlName="reticulocyte"
                                        type="checkbox"
                                    />
                                    Reticulocyte Count
                                </label>
                            </div>
                            <div style="grid-area: 1 / 2 / 2 / 3">
                                <label>
                                    <input
                                        formControlName="cbcNoDifferential"
                                        type="checkbox"
                                    />
                                    CBC no Differential
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    class="div5"
                    style="
                        border-top: 1px solid black;
                        border-left: 1px solid black;
                    "
                    formGroupName="endocrine"
                >
                    <div class="heading">Endocrine</div>
                    <div style="padding: 4px">
                        <div
                            style="
                                display: flex;
                                flex-direction: column;
                                gap: 2px;
                            "
                        >
                            <div>
                                <div>Cortisol</div>
                                <div
                                    style="
                                        display: flex;
                                        margin-left: 14px;
                                        gap: 10px;
                                    "
                                >
                                    <label style="white-space: nowrap">
                                        <input
                                            formControlName="random"
                                            type="checkbox"
                                        />
                                        Random
                                    </label>
                                    <label style="white-space: nowrap">
                                        <input
                                            formControlName="AM"
                                            type="checkbox"
                                        />
                                        AM<small>(0700-1000)</small>
                                    </label>
                                    <label style="white-space: nowrap">
                                        <input
                                            formControlName="PM"
                                            type="checkbox"
                                        />
                                        PM<small>(1500-1800)</small>
                                    </label>
                                </div>
                            </div>
                            <label>
                                <input
                                    formControlName="estradiol"
                                    type="checkbox"
                                />
                                Estradiol
                            </label>
                            <label>
                                <input formControlName="FSH" type="checkbox" />
                                Follicle Stimulating Hormone (FSH)
                            </label>
                            <label>
                                <input formControlName="LH" type="checkbox" />
                                Luteinizing Hormone (LH)
                            </label>
                            <label>
                                <input formControlName="PTH" type="checkbox" />
                                Parathyroid Hormone (PTH)
                            </label>
                            <label>
                                <input formControlName="progesterone" type="checkbox" />
                                Progesterone
                            </label>
                            <label>
                                <input
                                    formControlName="prolactin"
                                    type="checkbox"
                                />
                                Prolactin
                            </label>
                            <label>
                                <input
                                    formControlName="testosteroneTotal"
                                    type="checkbox"
                                />
                                Testosterone, Total
                            </label>
                            <label>
                                <input formControlName="TSH" type="checkbox" />
                                Thyroid Stimulating Hormone (TSH)
                            </label>
                            <label>
                                <input
                                    formControlName="TSH_Progressive"
                                    type="checkbox"
                                />
                                Thyroid Stimulating Hormone (TSH), Progressive
                            </label>
                        </div>
                    </div>
                </div>
                <div
                    class="div6"
                    style="
                        border-top: 1px solid black;
                        border-left: 1px solid black;
                    "
                    formGroupName="clinicalInformation"
                >
                    <div class="heading">Clinical Information</div>
                    <div style="padding: 4px">
                        <textarea
                            formControlName="clinicalInformation"
                            rows="2"
                        ></textarea>
                    </div>
                </div>
                <div
                    class="div7"
                    formGroupName="generalChemistry"
                    style="border-top: 1px solid black"
                >
                    <div class="heading">General Chemistry</div>
                    <div style="padding: 4px">
                        <div style="display: flex; flex-direction: column">
                            <label>
                                <input
                                    formControlName="albumin"
                                    type="checkbox"
                                />
                                Albumin
                            </label>
                            <label>
                                <input formControlName="ALP" type="checkbox" />
                                Alkaline Phosphatase (ALP)
                            </label>
                            <label>
                                <input formControlName="ALT" type="checkbox" />
                                Alanine Aminotransferase (ALT)
                            </label>
                            <div
                                style="
                                    display: flex;
                                    justify-content: space-between;
                                "
                            >
                                <label>
                                    <input
                                        formControlName="bilirubin"
                                        type="checkbox"
                                    />
                                    Bilirubin, Total
                                </label>
                                <div>OR</div>
                                <label>
                                    <input
                                        formControlName="conjugated"
                                        type="checkbox"
                                    />
                                    Total and Conjugated
                                </label>
                            </div>
                            <label>
                                <input
                                    formControlName="calcium"
                                    type="checkbox"
                                />
                                Calcium
                            </label>
                            <label>
                                <input formControlName="CRP" type="checkbox" />
                                C-Reactive Protein (CRP)
                            </label>
                            <label>
                                <input formControlName="CK" type="checkbox" />
                                Creatine Kinase (CK)
                            </label>
                            <label>
                                <input formControlName="eGFR" type="checkbox" />
                                Creatinine (eGFR)
                            </label>
                            <label>
                                <input
                                    formControlName="ferritin"
                                    type="checkbox"
                                />
                                Ferritin
                            </label>
                            <label>
                                <input formControlName="GGT" type="checkbox" />
                                Gamma Glutamyl Transferase (GGT)
                            </label>
                            <label>
                                <input
                                    formControlName="glucoseFasting"
                                    type="checkbox"
                                />
                                Glucose Fasting Ⓕ Ⓘ
                            </label>
                            <label>
                                <input formControlName="GDS" type="checkbox" />
                                Glucose Gestational Diabetes Screen (GDS)
                            </label>
                            <label>
                                <input
                                    formControlName="glucoseToleranceGestational2h"
                                    type="checkbox"
                                />
                                Glucose Tolerance, Gestational, 2 h Ⓕ Ⓘ
                            </label>
                            <label>
                                <input
                                    formControlName="glucoseRandom"
                                    type="checkbox"
                                />
                                Glucose Random
                            </label>
                            <label>
                                <input
                                    formControlName="glucoseTolerance2h"
                                    type="checkbox"
                                />
                                Glucose Tolerance, 2 h Ⓕ Ⓘ
                            </label>
                            <label>
                                <input
                                    formControlName="hemoglobinA1c"
                                    type="checkbox"
                                />
                                Hemoglobin A1c
                            </label>
                            <label>
                                <input formControlName="HCG" type="checkbox" />
                                HCG, Serum (Quantitative)
                            </label>
                            <div
                                style="
                                    display: flex;
                                    justify-content: space-between;
                                "
                            >
                                <div>Immunoglobulins:</div>
                                <label>
                                    <input
                                        formControlName="IgA"
                                        type="checkbox"
                                    />
                                    IgA
                                </label>
                                <label>
                                    <input
                                        formControlName="IgG"
                                        type="checkbox"
                                    />
                                    IgG
                                </label>
                                <label>
                                    <input
                                        formControlName="lgM"
                                        type="checkbox"
                                    />
                                    lgM
                                </label>
                            </div>
                            <label>
                                <input
                                    formControlName="lipase"
                                    type="checkbox"
                                />
                                Lipase
                            </label>
                            <label>
                                <input
                                    formControlName="magnesium"
                                    type="checkbox"
                                />
                                Magnesium
                            </label>
                            <label>
                                <input
                                    formControlName="phosphate"
                                    type="checkbox"
                                />
                                Phosphate
                            </label>
                            <label>
                                <input formControlName="PSA" type="checkbox" />
                                Prostate Specific Antigen (PSA)
                            </label>
                            <label>
                                <input
                                    formControlName="proteinElectrophoresisSerum"
                                    type="checkbox"
                                />
                                Protein Electrophoresis, Serum
                            </label>
                            <div style="display: flex; gap: 40px">
                                <label>
                                    <input
                                        formControlName="NA"
                                        type="checkbox"
                                    />
                                    Sodium (NA)
                                </label>
                                <label>
                                    <input
                                        formControlName="K"
                                        type="checkbox"
                                    />
                                    Potassium (K)
                                </label>
                            </div>
                            <label>
                                <input
                                    formControlName="totalProtein"
                                    type="checkbox"
                                />
                                Total Protein
                            </label>
                            <label>
                                <input
                                    formControlName="urate"
                                    type="checkbox"
                                />
                                Urate
                            </label>

                            <div style="border-bottom: 1px solid black"></div>

                            <div
                                style="
                                    display: grid;
                                    grid-template-columns: repeat(2, 1fr);
                                    grid-template-rows: repeat(2, 1fr) 2fr;
                                    grid-column-gap: 0px;
                                    grid-row-gap: 0px;
                                "
                            >
                                <div style="grid-area: 1 / 1 / 2 / 2">
                                    <label>
                                        <input
                                            formControlName="lipidPanel"
                                            type="checkbox"
                                        />
                                        Lipid Panel
                                    </label>
                                </div>
                                <div style="grid-area: 1 / 2 / 2 / 3">
                                    <label>
                                        <input
                                            formControlName="cholesterolTotal"
                                            type="checkbox"
                                        />
                                        Cholesterol, Total
                                    </label>
                                </div>
                                <div style="grid-area: 2 / 2 / 3 / 3">
                                    <label>
                                        <input
                                            formControlName="triglycerides"
                                            type="checkbox"
                                        />
                                        Triglycerides
                                    </label>
                                </div>
                                <div style="grid-area: 3 / 1 / 4 / 3">
                                    <label>
                                        <input
                                            formControlName="FRS"
                                            type="checkbox"
                                        />
                                        Cardiovascular Disease Risk Assessment
                                        (Framingham Risk Score) includes Lipid
                                        Panel
                                    </label>
                                </div>
                            </div>

                            <b>Required History</b>

                            <div style="display: flex; gap: 8px">
                                <div style="white-space: nowrap">
                                    Systolic Blood Pressure
                                </div>
                                <input
                                    formControlName="systolicBloodPressure"
                                    type="text"
                                    style="border-bottom: 1px solid black"
                                />
                            </div>

                            <div
                                style="
                                    display: flex;
                                    justify-content: space-between;
                                "
                                formGroupName="tobaccoUse"
                            >
                                <div>Tobacco Use</div>
                                <div style="display: flex; gap: 30px">
                                    <label>
                                        <input
                                            formControlName="yes"
                                            type="checkbox"
                                        />
                                        Yes
                                    </label>
                                    <label>
                                        <input
                                            formControlName="no"
                                            type="checkbox"
                                        />
                                        No
                                    </label>
                                </div>
                            </div>
                            <div
                                style="
                                    display: flex;
                                    justify-content: space-between;
                                "
                                formGroupName="treatedForHighBloodPressure"
                            >
                                <div>Treated for high Blood Pressure</div>
                                <div style="display: flex; gap: 30px">
                                    <label>
                                        <input
                                            formControlName="yes"
                                            type="checkbox"
                                        />
                                        Yes
                                    </label>
                                    <label>
                                        <input
                                            formControlName="no"
                                            type="checkbox"
                                        />
                                        No
                                    </label>
                                </div>
                            </div>
                            <div
                                formGroupName="diabetic"
                                style="display: flex; gap: 20px"
                            >
                                <div>Diabetic</div>
                                <div style="display: flex; gap: 30px">
                                    <label>
                                        <input
                                            formControlName="yes"
                                            type="checkbox"
                                        />
                                        Yes
                                    </label>
                                    <label>
                                        <input
                                            formControlName="no"
                                            type="checkbox"
                                        />
                                        No
                                    </label>
                                </div>
                            </div>
                            <div
                                formGroupName="chronicKidneyDisease"
                                style="display: flex; gap: 50px"
                            >
                                <div>Chronic Kidney Disease</div>
                                <div style="display: flex; gap: 50px">
                                    <label>
                                        <input
                                            formControlName="yes"
                                            type="checkbox"
                                        />
                                        Yes
                                    </label>
                                    <label>
                                        <input
                                            formControlName="no"
                                            type="checkbox"
                                        />
                                        No
                                    </label>
                                </div>
                            </div>
                            <div
                                formGroupName="atherosclerosis"
                                style="display: flex; gap: 20px"
                            >
                                <div>Atherosclerosis (MI, Stroke)</div>
                                <div style="display: flex; gap: 50px">
                                    <label>
                                        <input
                                            formControlName="yes"
                                            type="checkbox"
                                        />
                                        Yes
                                    </label>
                                    <label>
                                        <input
                                            formControlName="no"
                                            type="checkbox"
                                        />
                                        No
                                    </label>
                                </div>
                            </div>
                            <div
                                formGroupName="firstDegreeRelativeWithCardiovascularDisease"
                            >
                                <span>
                                    First-degree relative with Cardiovascular
                                    Disease (M <55 / F <65)
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    <label>
                                        <input
                                            formControlName="yes"
                                            type="checkbox"
                                        />
                                        Yes
                                    </label>
                                    <label>
                                        <input
                                            formControlName="no"
                                            type="checkbox"
                                        />
                                        No
                                    </label>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    formGroupName="sterileBodyFluid"
                    class="div8"
                    style="border-top: 1px solid black"
                >
                    <div class="heading">Sterile Body Fluid</div>
                    <div style="padding: 4px">
                        <div
                            style="display: flex; gap: 4px; align-items: center"
                        >
                            <label style="display: flex; white-space: nowrap">
                                <input formControlName="yes" type="checkbox" />
                                Fluid Type
                            </label>
                            <input
                                formControlName="fluidType"
                                type="text"
                                style="border-bottom: 1px solid black"
                            />
                            <div>Source:</div>
                            <input
                                formControlName="source"
                                type="text"
                                style="border-bottom: 1px solid black"
                            />
                        </div>
                        <div style="display: flex; gap: 4px">
                            <div>Test(s)</div>
                            <input
                                formControlName="tests"
                                type="text"
                                style="border-bottom: 1px solid black"
                            />
                        </div>
                    </div>
                </div>
                <div
                    formGroupName="miscellaneous"
                    class="div9"
                    style="border-top: 1px solid black"
                >
                    <div class="heading">Miscellaneous</div>
                    <div style="padding: 4px">
                        <div style="display: flex; flex-direction: column">
                            <label>
                                <input formControlName="FIT" type="checkbox" />
                                FIT Colorectal Cancer Screening (Age 50-74) Ⓘ
                            </label>
                            <label>
                                <input formControlName="H" type="checkbox" />
                                H. pylori Test Ⓘ
                            </label>
                            <label>
                                <input formControlName="HI" type="checkbox" />
                                Hemoglobinopathy Investigation
                            </label>
                        </div>
                    </div>
                </div>
                <div
                    class="div10"
                    style="
                        border-top: 1px solid black;
                        border-left: 1px solid black;
                    "
                    formGroupName="urine"
                >
                    <div class="heading">Urine</div>
                    <div style="padding: 4px">
                        <div style="display: flex; flex-direction: column">
                            <label>
                                <input
                                    formControlName="urinalysis"
                                    type="checkbox"
                                />
                                Urinalysis
                            </label>
                            <label>
                                <input
                                    formControlName="pregnancyTest"
                                    type="checkbox"
                                />
                                Pregnancy Test (HCG, Qualitative)
                            </label>
                            <label>
                                <input
                                    formControlName="proteinRandom"
                                    type="checkbox"
                                />
                                Protein Random (Creatinine Ratio)
                            </label>

                            <div
                                style="
                                    display: flex;
                                    justify-content: space-between;
                                "
                                formGroupName="albumin"
                            >
                                <div>Albumin (Creatinine Ratio)</div>
                                <div style="display: flex; gap: 20px">
                                    <label>
                                        <input
                                            formControlName="random"
                                            type="checkbox"
                                        />
                                        Random
                                    </label>
                                    <label>
                                        <input
                                            formControlName="h24"
                                            type="checkbox"
                                        />
                                        24 h
                                    </label>
                                </div>
                            </div>
                            <div
                                style="
                                    display: flex;
                                    justify-content: space-between;
                                "
                                formGroupName="creatinine"
                            >
                                <div>Creatinine</div>
                                <div style="display: flex; gap: 20px">
                                    <label>
                                        <input
                                            formControlName="random"
                                            type="checkbox"
                                        />
                                        Random
                                    </label>
                                    <label>
                                        <input
                                            formControlName="h24"
                                            type="checkbox"
                                        />
                                        24 h
                                    </label>
                                </div>
                            </div>
                            <div
                                style="
                                    display: flex;
                                    justify-content: space-between;
                                "
                                formGroupName="cortisol"
                            >
                                <div>Cortisol</div>
                                <div style="display: flex; gap: 20px">
                                    <label>
                                        <input
                                            formControlName="random"
                                            type="checkbox"
                                        />
                                        Random
                                    </label>
                                    <label>
                                        <input
                                            formControlName="h24"
                                            type="checkbox"
                                        />
                                        24 h
                                    </label>
                                </div>
                            </div>
                            <div
                                style="
                                    display: flex;
                                    justify-content: space-between;
                                "
                                formGroupName="proteinTotal"
                            >
                                <div>Protein Total</div>
                                <div style="display: flex; gap: 20px">
                                    <label>
                                        <input
                                            formControlName="random"
                                            type="checkbox"
                                        />
                                        Random
                                    </label>
                                    <label>
                                        <input
                                            formControlName="h24"
                                            type="checkbox"
                                        />
                                        24 h
                                    </label>
                                </div>
                            </div>
                            <div
                                style="
                                    display: flex;
                                    justify-content: space-between;
                                "
                                formGroupName="proteinElectrophoresis"
                            >
                                <div>Protein Electrophoresis</div>
                                <div style="display: flex; gap: 20px">
                                    <label>
                                        <input
                                            formControlName="random"
                                            type="checkbox"
                                        />
                                        Random
                                    </label>
                                    <label>
                                        <input
                                            formControlName="h24"
                                            type="checkbox"
                                        />
                                        24 h
                                    </label>
                                </div>
                            </div>

                            <div style="display: flex; gap: 14px">
                                <div>
                                    <label style="white-space: nowrap">
                                        <input
                                            formControlName="creatinineClearance24h"
                                            type="checkbox"
                                        />
                                        Creatinine Clearance 24h
                                    </label>
                                </div>
                                <div>
                                    <div style="display: flex; gap: 4px">
                                        <div>Ht</div>
                                        <input
                                            formControlName="ht"
                                            type="text"
                                            style="
                                                border-bottom: 1px solid black;
                                            "
                                        />
                                        <div>cm</div>
                                    </div>
                                    <div style="display: flex; gap: 4px">
                                        <div>Wt</div>
                                        <input
                                            formControlName="wt"
                                            type="text"
                                            style="
                                                border-bottom: 1px solid black;
                                            "
                                        />
                                        <div>kg</div>
                                    </div>
                                </div>
                            </div>

                            <div
                                style="
                                    display: flex;
                                    justify-content: space-between;
                                "
                            >
                                <b>24H Urine Ⓘ</b>
                                <div style="flex: 1"></div>
                                <div
                                    style="display: flex; align-items: baseline"
                                >
                                    <div style="white-space: nowrap">
                                        Total Volume
                                    </div>
                                    <input
                                        formControlName="totalVolume"
                                        type="text"
                                        style="
                                            border-bottom: 1px solid black;
                                            width: 100px;
                                        "
                                    />
                                </div>
                            </div>
                            <div
                                style="
                                    display: flex;
                                    justify-content: space-between;
                                    align-items: center;
                                    gap: 4px;
                                "
                            >
                                <div style="white-space: nowrap">
                                    Start Date
                                </div>
                                <input
                                    formControlName="startDate1"
                                    type="text"
                                    style="border-bottom: 1px solid black"
                                />
                                <div style="white-space: nowrap">
                                    Start Date
                                </div>
                                <input
                                    formControlName="startDate2"
                                    type="text"
                                    style="border-bottom: 1px solid black"
                                />
                            </div>
                            <div
                                style="
                                    display: flex;
                                    justify-content: space-between;
                                    align-items: center;
                                    gap: 4px;
                                "
                            >
                                <div style="white-space: nowrap">End Date</div>
                                <input
                                    formControlName="endDate1"
                                    type="text"
                                    style="border-bottom: 1px solid black"
                                />
                                <div style="white-space: nowrap">End Date</div>
                                <input
                                    formControlName="endDate2"
                                    type="text"
                                    style="border-bottom: 1px solid black"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    class="div11"
                    style="
                        border-top: 1px solid black;
                        border-left: 1px solid black;
                    "
                    formGroupName="transfusionMedicine"
                >
                    <div class="heading">Transfusion Medicine</div>
                    <div
                        style="
                            padding: 4px;
                            display: flex;
                            flex-direction: column;
                        "
                    >
                        <label>
                            <input formControlName="DAT" type="checkbox" />
                            Direct Antiglobulin Test (DAT)
                        </label>
                        <label>
                            <input formControlName="RHIG" type="checkbox" />
                            RHIG Eligibility, Prenatal
                        </label>
                        <div>Type & Screen - See TM Requisition</div>
                        <div>Prenatal RBC Serology – use CBS Perinatal Req</div>
                    </div>
                </div>
                <div
                    class="div12"
                    style="
                        border-top: 1px solid black;
                        border-left: 1px solid black;
                    "
                    formGroupName="cardiology"
                >
                    <div class="heading">Cardiology</div>
                    <div
                        style="
                            padding: 4px;
                            display: flex;
                            flex-direction: column;
                        "
                    >
                        <label>
                            <input
                                formControlName="electrocardiogram"
                                type="checkbox"
                            />
                            Electrocardiogram
                        </label>
                        <div><b>Edmonton</b> ECG to be read by</div>
                        <div
                            style="display: flex; justify-content: space-around"
                        >
                            <label>
                                <input
                                    formControlName="dynalifePanel"
                                    type="checkbox"
                                />
                                Dynalife panel
                            </label>

                            <div style="display: flex; gap: 4px">
                                <label>
                                    <input
                                        formControlName="other"
                                        type="checkbox"
                                    />
                                    Other
                                </label>
                                <input
                                    formControlName="otherText"
                                    type="text"
                                    style="
                                        border-bottom: 1px solid black;
                                        width: 120px;
                                    "
                                />
                            </div>
                        </div>
                        <div><b>Calgary</b> See Separate ECG Requisition</div>
                        <input formControlName="calgary" type="text" />
                    </div>
                </div>
                <div
                    class="div13"
                    style="
                        border-top: 1px solid black;
                        border-left: 1px solid black;
                    "
                    formGroupName="immunology"
                >
                    <div class="heading">Immunology/Serology</div>
                    <div style="padding: 4px">
                        <div style="display: flex; flex-direction: column">
                            <label>
                                <input
                                    formControlName="epstein"
                                    type="checkbox"
                                />
                                Epstein Barr Serology Panel
                            </label>
                            <label>
                                <input formControlName="IgM" type="checkbox" />
                                Hepatitis A Virus Acute Serology - IgM
                            </label>
                            <label>
                                <input formControlName="IgG" type="checkbox" />
                                Hepatitis A Virus Immunity Serology - IgG
                            </label>
                            <label>
                                <input
                                    formControlName="hepatitisBSurfaceAntigen"
                                    type="checkbox"
                                />
                                Hepatitis B Surface Antigen
                            </label>
                            <label>
                                <input
                                    formControlName="hepatitisBSurfaceAntibody"
                                    type="checkbox"
                                />
                                Hepatitis B Surface Antibody
                            </label>
                            <label>
                                <input
                                    formControlName="hepatitisCVirusSerology"
                                    type="checkbox"
                                />
                                Hepatitis C Virus Serology
                            </label>
                            <label>
                                <input formControlName="HIV" type="checkbox" />
                                HIV 1 and 2 Serology (Antigen and Antibody)
                            </label>
                            <label>
                                <input
                                    formControlName="mononucleosisScreen"
                                    type="checkbox"
                                />
                                Mononucleosis Screen
                            </label>
                            <label>
                                <input
                                    formControlName="rheumatoidFactor"
                                    type="checkbox"
                                />
                                Rheumatoid Factor
                            </label>
                            <label>
                                <input
                                    formControlName="rubellaImmunitySerologyIgG"
                                    type="checkbox"
                                />
                                Rubella Immunity Serology - IgG
                            </label>
                            <label>
                                <input
                                    formControlName="syphilisScreen"
                                    type="checkbox"
                                />
                                Syphilis screen
                            </label>
                        </div>
                    </div>
                </div>
                <div
                    class="div14"
                    style="
                        border-top: 1px solid black;
                        border-left: 1px solid black;
                    "
                    formGroupName="drugLevelsMonitoring"
                >
                    <div class="heading">Drug Levels/Monitoring</div>
                    <div
                        style="
                            padding: 4px;
                            display: flex;
                            flex-direction: column;
                        "
                    >
                        <label>
                            <input
                                formControlName="ethanolLevelBlood"
                                type="checkbox"
                            />
                            Ethanol Level, Blood
                        </label>
                        <b>Therapeutic Drug Monitoring</b>
                        <div
                            formGroupName="doseRoute"
                            style="display: flex; gap: 24px"
                        >
                            <div>Dose route</div>
                            <label>
                                <input formControlName="oral" type="checkbox" />
                                Oral
                            </label>
                            <label>
                                <input formControlName="IV" type="checkbox" />
                                IV
                            </label>
                            <label>
                                <input
                                    formControlName="other"
                                    type="checkbox"
                                />
                                Other
                            </label>
                        </div>
                        <div style="display: flex">
                            <div style="white-space: nowrap; align-self: end">
                                Dose Regimen
                            </div>
                            <input
                                formControlName="doseRegimen"
                                type="text"
                                style="border-bottom: 1px solid black"
                            />
                        </div>
                        <div style="display: flex">
                            <div style="white-space: nowrap; align-self: end">
                                How Long on Current Regimen?
                            </div>
                            <input
                                formControlName="howLongOnCurrentRegimen"
                                type="text"
                                style="
                                    border-bottom: 1px solid black;
                                    width: 120px;
                                "
                            />
                        </div>
                        <div style="display: flex">
                            <div style="white-space: nowrap; align-self: end">
                                Date of Last Dose or IV Complete
                            </div>
                            <input
                                formControlName="dateOfLastDoseOrIVComplete"
                                type="text"
                                style="
                                    border-bottom: 1px solid black;
                                    width: 120px;
                                "
                            />
                        </div>
                        <div style="display: flex">
                            <div style="white-space: nowrap; align-self: end">
                                Time of Last Dose or IV Complete
                            </div>
                            <input
                                formControlName="timeOfLastDoseOrIvComplete"
                                type="text"
                                style="
                                    border-bottom: 1px solid black;
                                    width: 120px;
                                "
                            />
                        </div>
                        <div style="display: flex">
                            <div style="white-space: nowrap; align-self: end">
                                Date of Next Dose or IV Start
                            </div>
                            <input
                                formControlName="dateOfNextDoseOrIvStart"
                                type="text"
                                style="
                                    border-bottom: 1px solid black;
                                    width: 120px;
                                "
                            />
                        </div>
                        <div style="display: flex">
                            <div style="white-space: nowrap; align-self: end">
                                Time of Next Dose or IV Start
                            </div>
                            <input
                                formControlName="timeOfNextDoseOrIvStart"
                                type="text"
                                style="
                                    border-bottom: 1px solid black;
                                    width: 120px;
                                "
                            />
                        </div>

                        <div
                            style="
                                display: grid;
                                grid-template-columns: repeat(2, 1fr);
                                grid-template-rows: repeat(6, 1fr);
                                grid-column-gap: 0px;
                                grid-row-gap: 0px;
                                margin-top: 4px;
                            "
                        >
                            <div style="grid-area: 1 / 1 / 2 / 2">
                                <label style="white-space: nowrap">
                                    <input
                                        formControlName="carbamazepine"
                                        type="checkbox"
                                    />
                                    Carbamazepine
                                </label>
                            </div>
                            <div style="grid-area: 1 / 2 / 2 / 3">
                                <label style="white-space: nowrap">
                                    <input
                                        formControlName="phenytoinTotal"
                                        type="checkbox"
                                    />
                                    Phenytoin, Total
                                </label>
                            </div>
                            <div style="grid-area: 2 / 1 / 3 / 2">
                                <label style="white-space: nowrap">
                                    <input
                                        formControlName="cyclosporinePreDose"
                                        type="checkbox"
                                    />
                                    Cyclosporine pre dose
                                </label>
                            </div>
                            <div style="grid-area: 2 / 2 / 3 / 3">
                                <label style="white-space: nowrap">
                                    <input
                                        formControlName="sirolimus"
                                        type="checkbox"
                                    />
                                    Sirolimus
                                </label>
                            </div>
                            <div style="grid-area: 3 / 1 / 4 / 2">
                                <label style="white-space: nowrap">
                                    <input
                                        formControlName="cyclosporine2HPost"
                                        type="checkbox"
                                    />
                                    Cyclosporine 2 h post
                                </label>
                            </div>
                            <div style="grid-area: 3 / 2 / 4 / 3">
                                <label style="white-space: nowrap">
                                    <input
                                        formControlName="tacrolimus"
                                        type="checkbox"
                                    />
                                    Tacrolimus
                                </label>
                            </div>
                            <div style="grid-area: 4 / 1 / 5 / 2">
                                <label style="white-space: nowrap">
                                    <input
                                        formControlName="digoxin"
                                        type="checkbox"
                                    />
                                    Digoxin
                                </label>
                            </div>
                            <div style="grid-area: 4 / 2 / 5 / 3">
                                <label style="white-space: nowrap">
                                    <input
                                        formControlName="theophylline"
                                        type="checkbox"
                                    />
                                    Theophylline
                                </label>
                            </div>
                            <div style="grid-area: 5 / 1 / 6 / 2">
                                <label style="white-space: nowrap">
                                    <input
                                        formControlName="lithium"
                                        type="checkbox"
                                    />
                                    Lithium
                                </label>
                            </div>
                            <div style="grid-area: 5 / 2 / 6 / 3">
                                <label style="white-space: nowrap">
                                    <input
                                        formControlName="valproate"
                                        type="checkbox"
                                    />
                                    Valproate
                                </label>
                            </div>
                            <div style="grid-area: 6 / 1 / 7 / 2">
                                <label style="white-space: nowrap">
                                    <input
                                        formControlName="phenobarbital"
                                        type="checkbox"
                                    />
                                    Phenobarbital
                                </label>
                            </div>
                            <div style="grid-area: 6 / 2 / 7 / 3">
                                <div style="display: flex; gap: 4px">
                                    <label style="white-space: nowrap">
                                        <input
                                            formControlName="other"
                                            type="checkbox"
                                        />
                                        Other
                                    </label>
                                    <input
                                        formControlName="otherText"
                                        type="text"
                                        style="border-bottom: 1px solid black"
                                    />
                                </div>
                            </div>
                        </div>

                        <b style="margin-top: 4px">Antibiotics</b>

                        <div
                            style="
                                display: grid;
                                grid-template-columns: repeat(5, 1fr);
                                grid-template-rows: repeat(3, 1fr);
                                grid-column-gap: 0px;
                                grid-row-gap: 0px;
                            "
                        >
                            <ng-container formGroupName="gentamicin">
                                <div style="grid-area: 1 / 1 / 2 / 2">
                                    Gentamicin
                                </div>
                                <div style="grid-area: 1 / 2 / 2 / 3">
                                    <label style="white-space: nowrap">
                                        <input
                                            formControlName="pre"
                                            type="checkbox"
                                        />
                                        Pre
                                    </label>
                                </div>
                                <div style="grid-area: 1 / 3 / 2 / 4">
                                    <label style="white-space: nowrap">
                                        <input
                                            formControlName="post"
                                            type="checkbox"
                                        />
                                        Post
                                    </label>
                                </div>
                                <div style="grid-area: 1 / 4 / 2 / 5">
                                    <label style="white-space: nowrap">
                                        <input
                                            formControlName="interval"
                                            type="checkbox"
                                        />
                                        Interval
                                    </label>
                                </div>
                                <div style="grid-area: 1 / 5 / 2 / 6">
                                    <label style="white-space: nowrap">
                                        <input
                                            formControlName="other"
                                            type="checkbox"
                                        />
                                        Other
                                    </label>
                                </div>
                            </ng-container>
                            <ng-container formGroupName="tobramycin">
                                <div style="grid-area: 2 / 1 / 3 / 2">
                                    Tobramycin
                                </div>
                                <div style="grid-area: 2 / 2 / 3 / 3">
                                    <label style="white-space: nowrap">
                                        <input
                                            formControlName="pre"
                                            type="checkbox"
                                        />
                                        Pre
                                    </label>
                                </div>
                                <div style="grid-area: 2 / 3 / 3 / 4">
                                    <label style="white-space: nowrap">
                                        <input
                                            formControlName="post"
                                            type="checkbox"
                                        />
                                        Post
                                    </label>
                                </div>
                                <div style="grid-area: 2 / 4 / 3 / 5">
                                    <label style="white-space: nowrap">
                                        <input
                                            formControlName="interval"
                                            type="checkbox"
                                        />
                                        Interval
                                    </label>
                                </div>
                                <div style="grid-area: 2 / 5 / 3 / 6">
                                    <label style="white-space: nowrap">
                                        <input
                                            formControlName="other"
                                            type="checkbox"
                                        />
                                        Other
                                    </label>
                                </div>
                            </ng-container>
                            <ng-container formGroupName="vancomycin">
                                <div style="grid-area: 3 / 1 / 4 / 2">
                                    Vancomycin
                                </div>
                                <div style="grid-area: 3 / 2 / 4 / 3">
                                    <label style="white-space: nowrap">
                                        <input
                                            formControlName="pre"
                                            type="checkbox"
                                        />
                                        Pre
                                    </label>
                                </div>
                                <div style="grid-area: 3 / 5 / 4 / 6">
                                    <label style="white-space: nowrap">
                                        <input
                                            formControlName="other"
                                            type="checkbox"
                                        />
                                        Other
                                    </label>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </div>
                <div
                    class="div15"
                    style="
                        border-top: 1px solid black;
                        border-left: 1px solid black;
                    "
                    formGroupName="additionalTests"
                >
                    <div class="heading">Additional Tests</div>
                    <div
                        style="
                            padding: 4px;
                            display: flex;
                            flex-direction: column;
                        "
                    >
                        <textarea
                            formControlName="additionalTests"
                            rows="10"
                            style="
                                white-space: pre-wrap;
                                overflow-wrap: anywhere;
                                word-break: break-word;
                            "
                        ></textarea>
                    </div>
                </div>
                <div class="div16" style="border-left: 1px solid black">
                    <div
                        formGroupName="urineDrugTestingPanels"
                        style="border-top: 1px solid black"
                    >
                        <div class="heading">Urine Drug Testing Panels</div>
                        <div
                            style="
                                padding: 4px;
                                display: flex;
                                flex-direction: column;
                            "
                        >
                            <div style="display: flex; gap: 8px">
                                <div style="white-space: nowrap">
                                    Reason For Request
                                </div>
                                <input
                                    formControlName="reasonForRequest"
                                    type="text"
                                    style="border-bottom: 1px solid black"
                                />
                            </div>
                            <div
                                style="
                                    margin-top: 4px;
                                    margin-bottom: 4px;
                                    border-bottom: 1px solid black;
                                "
                            ></div>

                            <label style="white-space: nowrap">
                                <input
                                    formControlName="opioidDependencyPanel"
                                    type="checkbox"
                                />
                                Opioid Dependency Panel
                            </label>
                            <div>What is Treatment Regimen?</div>
                            <div
                                style="
                                    margin-left: 20px;
                                    display: grid;
                                    grid-template-columns: repeat(2, 1fr);
                                    grid-template-rows: repeat(3, 1fr);
                                    grid-column-gap: 0px;
                                    grid-row-gap: 0px;
                                "
                            >
                                <div style="grid-area: 1 / 1 / 2 / 2">
                                    <label style="white-space: nowrap">
                                        <input
                                            formControlName="buprenorphine"
                                            type="checkbox"
                                        />
                                        Buprenorphine
                                    </label>
                                </div>
                                <div style="grid-area: 1 / 2 / 2 / 3">
                                    <label style="white-space: nowrap">
                                        <input
                                            formControlName="methadone"
                                            type="checkbox"
                                        />
                                        Methadone
                                    </label>
                                </div>
                                <div style="grid-area: 2 / 1 / 3 / 2">
                                    <label style="white-space: nowrap">
                                        <input
                                            formControlName="morphine"
                                            type="checkbox"
                                        />
                                        Morphine
                                    </label>
                                </div>
                                <div style="grid-area: 2 / 2 / 3 / 3">
                                    <label style="white-space: nowrap">
                                        <input
                                            formControlName="hydromorphone"
                                            type="checkbox"
                                        />
                                        Hydromorphone
                                    </label>
                                </div>
                                <div style="grid-area: 3 / 1 / 4 / 3">
                                    <div style="display: flex">
                                        <label style="white-space: nowrap">
                                            <input
                                                formControlName="other"
                                                type="checkbox"
                                            />
                                            Other
                                        </label>
                                        <input
                                            formControlName="otherText"
                                            type="text"
                                            style="
                                                border-bottom: 1px solid black;
                                            "
                                        />
                                    </div>
                                </div>
                            </div>
                            <div>
                                <b>OR</b>
                            </div>
                            <label style="white-space: nowrap">
                                <input
                                    formControlName="generalToxicologyPanel"
                                    type="checkbox"
                                />
                                General Toxicology Panel
                            </label>
                        </div>
                    </div>
                    <div
                        formGroupName="chlamydiaGonorrhea"
                        style="border-top: 1px solid black"
                    >
                        <div class="heading">Chlamydia/Gonorrhea</div>
                        <div
                            style="
                                padding: 4px;
                                display: flex;
                                flex-direction: column;
                            "
                        >
                            <label style="white-space: nowrap">
                                <input
                                    formControlName="chlamydiaGonorrheaScreen"
                                    type="checkbox"
                                />
                                Chlamydia/Gonorrhea Screen
                            </label>

                            <div
                                style="
                                    display: grid;
                                    grid-template-columns: repeat(3, 1fr);
                                    grid-template-rows: repeat(2, 1fr);
                                    grid-column-gap: 0px;
                                    grid-row-gap: 0px;
                                "
                            >
                                <div style="grid-area: 1 / 1 / 2 / 2">
                                    If Pregnant:
                                </div>
                                <div style="grid-area: 1 / 2 / 2 / 3">
                                    <label style="white-space: nowrap">
                                        <input
                                            formControlName="initialScreen"
                                            type="checkbox"
                                        />
                                        Initial Screen
                                    </label>
                                </div>
                                <div style="grid-area: 1 / 3 / 2 / 4">
                                    <label style="white-space: nowrap">
                                        <input
                                            formControlName="rescreen"
                                            type="checkbox"
                                        />
                                        Rescreen
                                    </label>
                                </div>
                                <div style="grid-area: 2 / 2 / 3 / 3">
                                    <label style="white-space: nowrap">
                                        <input
                                            formControlName="testOfCure"
                                            type="checkbox"
                                        />
                                        Test of Cure
                                    </label>
                                </div>
                            </div>

                            <div
                                style="
                                    display: grid;
                                    grid-template-columns: repeat(4, 1fr);
                                    grid-template-rows: repeat(3, 1fr);
                                    grid-column-gap: 0px;
                                    grid-row-gap: 0px;
                                "
                            >
                                <div style="grid-area: 1 / 1 / 2 / 2">
                                    Source:
                                </div>
                                <div style="grid-area: 1 / 2 / 2 / 4">
                                    <label style="white-space: nowrap">
                                        <input
                                            formControlName="urine"
                                            type="checkbox"
                                        />
                                        Urine, first catch
                                    </label>
                                </div>
                                <div style="grid-area: 1 / 4 / 2 / 5">
                                    <label style="white-space: nowrap">
                                        <input
                                            formControlName="endocervix"
                                            type="checkbox"
                                        />
                                        Endocervix
                                    </label>
                                </div>
                                <div style="grid-area: 2 / 2 / 3 / 3">
                                    <label style="white-space: nowrap">
                                        <input
                                            formControlName="urethra"
                                            type="checkbox"
                                        />
                                        Urethra
                                    </label>
                                </div>
                                <div style="grid-area: 2 / 3 / 3 / 4">
                                    <label style="white-space: nowrap">
                                        <input
                                            formControlName="vagina"
                                            type="checkbox"
                                        />
                                        Vagina
                                    </label>
                                </div>
                                <div style="grid-area: 2 / 4 / 3 / 5">
                                    <label style="white-space: nowrap">
                                        <input
                                            formControlName="rectal"
                                            type="checkbox"
                                        />
                                        Rectal
                                    </label>
                                </div>
                                <div style="grid-area: 3 / 2 / 4 / 3">
                                    <label style="white-space: nowrap">
                                        <input
                                            formControlName="throat"
                                            type="checkbox"
                                        />
                                        Throat
                                    </label>
                                </div>
                                <div style="grid-area: 3 / 3 / 4 / 4">
                                    <label style="white-space: nowrap">
                                        <input
                                            formControlName="eye"
                                            type="checkbox"
                                        />
                                        Eye
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>